// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorLayoutView_container__1iWIJ","content":"ErrorLayoutView_content__39cEv"};